"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.htmlEncode = void 0;
/**
 * @deprecated use DOMPurify instead
 * @param input HTMLString
 */
function htmlEncode(input) {
    if (!input) {
        return "";
    }
    return input.
        replace(/&/g, "&amp;").
        replace(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g, (value) => {
        let hi = value.charCodeAt(0);
        let low = value.charCodeAt(1);
        return "&#" + (((hi - 0xD800) * 0x400) + (low - 0xDC00) + 0x10000) + ";";
    }).
        replace(/([^\#-~| |!])/g, (value) => {
        return "&#" + value.charCodeAt(0) + ";";
    }).
        replace(/</g, "&lt;").
        replace(/>/g, "&gt;");
}
exports.htmlEncode = htmlEncode;
//# sourceMappingURL=Util.js.map